import React from 'react';
import { SectionHeading } from './ui/SectionHeading';
import { upsells } from '../data/upsells';
export function NextSteps() {
  return <section className="w-full bg-shell px-5 py-16 sm:px-8 lg:py-24" data-id="element-102" data-mp="30o0qg6lkb94">
      <div className="mx-auto max-w-5xl" data-id="element-103" data-mp="3u9lbahi261lb">
        <SectionHeading overline="What's next" size="lg" title={<>
              Once you've mastered pressing,{' '}
              <span className="italic text-terracotta-500" data-id="element-105" data-mp="qqi9aljvvdnk">there's more to explore</span>
            </>} subtitle="If you fall in love with pressed flowers, these are the two next steps for turning your work into pieces that feel even more special — and sell even better." data-id="element-104" data-mp="3uamoosmjr067" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-106" data-mp="c248eg611z9n">
          {upsells.map(upsell => <article key={upsell.name} className="flex h-full flex-col overflow-hidden rounded-4xl border border-gold-200/60 bg-cream" data-id="element-107" data-mp="19j2ztwc416o7">
              <div className="bg-bone px-6 py-9" data-id="element-108" data-mp="3vgtjk6k6kre1">
                <img src={upsell.image} alt={`${upsell.name} cover`} className="mx-auto w-full max-w-[230px] drop-shadow-[0_22px_36px_rgba(56,52,44,0.2)]" data-id="element-109" data-mp="3vj6ah97x2c38" />
              </div>
              <div className="flex flex-1 flex-col px-6 py-7 sm:px-8" data-id="element-110" data-mp="3qptq5ba9srga">
                <h3 className="font-serif text-[1.75rem] leading-tight text-sage-800" data-id="element-111" data-mp="3bt2kika06ji8">
                  {upsell.name}
                </h3>
                <p className="mt-3 text-[14.5px] leading-relaxed text-ink-soft" data-id="element-112" data-mp="3gt8ggcnb2s64">
                  {upsell.body}
                </p>
                <ul className="mt-5 flex flex-wrap gap-2" data-id="element-113" data-mp="32u8rt4zsmd9y">
                  {upsell.highlights.map(highlight => <li key={highlight} className="rounded-full bg-sage-100 px-3 py-1 text-[11.5px] font-medium text-sage-700" data-id="element-114" data-mp="37tbwgobv2hhe">
                      {highlight}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}